import {inject, Injectable} from '@angular/core';
import { ModalService, DianModalConfig} from 'dian-ui2';
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ModalesService {
    private modalService  = inject(ModalService);
  constructor() { }
  private infoClic: Subject<any> = new Subject();
  private infoClic$= this.infoClic.asObservable();

  sendInfoClic(infoClik: any) {
    this.infoClic.next(infoClik);
  }

  getInfoClic() : Observable<any> {
    return this.infoClic$;
  }

  openModalError(header: string, content: string, noteColor: string | null){
    const config : DianModalConfig = {
      type: 'error'
    };
    this.openModalGeneral(config, header, content, noteColor);
  }
  openModalErrorButton(header: string, content: string, noteColor: string | null,
                       labelButonRight : string, labelButonLeft : string){
    const config : DianModalConfig = {
      type: 'error'
    };
    this.openModalGeneralButton(config, header, content, noteColor,  labelButonRight , labelButonLeft );
  }
  openModalInfo(header: string, content: string, noteColor: string | null){
    const config : DianModalConfig = {
      type: 'info'
    };
    this.openModalGeneral(config, header, content, noteColor);
  }
  openModalInfoButton(header: string, content: string, noteColor: string | null,
                      labelButonRight : string, labelButonLeft : string){
    const config : DianModalConfig = {
      type: 'info'
    };
    this.openModalGeneralButton(config, header, content, noteColor,  labelButonRight , labelButonLeft );
  }
  openModalSuccess(header: string, content: string, noteColor: string | null){
    const config : DianModalConfig = {
      type: 'success'
    };
    this.openModalGeneral(config, header, content, noteColor);
  }
  openModalSuccessButton(header: string, content: string, noteColor: string | null,
                         labelButonRight : string, labelButonLeft : string){
    const config : DianModalConfig = {
      type: 'success'
    };
    this.openModalGeneralButton(config, header, content, noteColor,labelButonRight , labelButonLeft );
  }
  openModalWarning(header: string, content: string, noteColor: string | null){
    const config : DianModalConfig = {
      type: 'warning'
    };
    this.openModalGeneral(config, header, content, noteColor);
  }
  openModalWarningButton(header: string, content: string, noteColor: string | null,
                         labelButonRight : string, labelButonLeft : string){
    const config : DianModalConfig = {
      type: 'warning'
    };
    this.openModalGeneralButton(config, header, content, noteColor,   labelButonRight , labelButonLeft );
  }
  openModalHelp(header: string, content: string, noteColor: string | null){
    const config : DianModalConfig = {
      type: 'help'
    };
    this.openModalGeneral(config, header, content, noteColor);
  }
  openModalHelpButton(header: string, content: string, noteColor: string | null,
                      labelButonRight : string, labelButonLeft : string){
    const config : DianModalConfig = {
      type: 'help'
    };
    this.openModalGeneralButton(config, header, content, noteColor,  labelButonRight , labelButonLeft );
  }
  private openModalGeneral(config: DianModalConfig , headerModal: string, contentModal: string, noteModal: string | null){
    config.header = headerModal;
    config.content = contentModal;
    if (noteModal)
      config.note = noteModal;

    this.modalService.open(null, config).subscribe((modalResponse:any) => {
      console.log(modalResponse);
    });
  }
  private openModalGeneralButton(config: DianModalConfig , headerModal: string, contentModal: string, noteModal: string | null,
                                labelButonRight : string, labelButonLeft : string ){
    config.header = headerModal;
    config.content = contentModal;
    config.leftActionLabel = labelButonLeft;
    config.leftActionData = {key: 'no', key2: 'value '};
    config.rightActionLabel = labelButonRight;
    config.rightActionData = {key: 'yes', key2: 'value '};

    if (noteModal)
      config.note = noteModal;

    this.modalService.open(null, config).subscribe((modalResponse:any) => {
      this.sendInfoClic( modalResponse);
      console.log(`- - - - Modal  - - - - - >  ${modalResponse} `);

    });
  }
}
